import { useLocation } from "react-router";

import { ROUTES } from "../../../../../shared";

const useChangeCompanyFunctions = () => {
  const location = useLocation();

  const dashboardPage = location.pathname === ROUTES.Dashboard;

  const refreshPageData = (refreshTable: () => void) => {
    !dashboardPage && refreshTable(); // dashboard refresh is handled in the dashboard wrapper
  };

  return { refreshPageData };
};

export default useChangeCompanyFunctions;
